import React from 'react'
import { Box, Text } from '@usap/uicomponents'

import warranty from '../../../../config/warranty'
import commaSeparetedValue from '../../../../helpers/commaSeparetedValue'

import {
  PartNoBox,
  ItemTotalBox,
  ItemTotalValue,
  ShippingMethodValue,
} from './Information.css'

const orderItemShippingMethod = method => {
  const methods = {
    FDXOVR: 'Next Business Day',
    FDX2ND: '2nd Business Day',
    FDX: 'Standard',
  }

  return methods[`${method}`] || method
}

const Information = ({
  vehicle,
  product,
  core,
  formatBrand,
}) => {
  const warrantyLabel = product.warrantyCode && warranty[product.warrantyCode]
    ? warranty[product.warrantyCode]
    : ''
  const unitPrice = commaSeparetedValue(product.itemTotalUnitPrice)
  const unitPricePerEach = product.qty > 1
    ? ` ($${commaSeparetedValue(product.regularPrice)} each)`
    : ''

  const hasWarranty = Boolean(product.itemTotalWarranty) && Number(product.itemTotalWarranty) !== 0
  const warrantyPrice = commaSeparetedValue(product.itemTotalWarranty)
  const warrantyPriceEach = product.qty > 1 ? ` ($${commaSeparetedValue(product.cpp)} each)` : ''

  let vehicleBadge = 'FOR YOUR VEHICLE'
  if (vehicle && vehicle.year) {
    vehicleBadge = `FOR ${vehicle.year} ${vehicle.make} ${vehicle.model}`
    if (vehicle.submodel) {
      vehicleBadge += ` ${vehicle.submodel}`
      if (vehicle.engine) {
        vehicleBadge += ` ${vehicle.engine}`
      }
    }
  }

  return (
    <>
      <Box>
        <Text size="xsmall" color="dark-1" truncate>
          {vehicleBadge}
        </Text>
      </Box>
      {product.brand && (
        <Box>
          <Text weight={700} size="small" color="dark-2">
            {formatBrand(product.brand)}
          </Text>
        </Box>
      )}
      <Box>
        <Text size="small" color="dark-2" truncate>
          {product.title}
        </Text>
      </Box>

      <PartNoBox>
        <Text size="xsmall" color="dark-1" truncate>
          {`Part No. ${product.partNumber}`}
        </Text>
      </PartNoBox>

      <Box>
        <Text size="small" color="dark-2" truncate>
          {`Qty: ${product.qty}`}
        </Text>
      </Box>

      <Box>
        <Text size="small" color="dark-2" truncate>
          {`Unit Price: $${unitPrice}${unitPricePerEach}`}
        </Text>
      </Box>

      { core}
      {hasWarranty && (
        <Box>
          <Text size="small" color="dark-2" truncate>
            {`${warrantyLabel}: $${warrantyPrice}${warrantyPriceEach}`}
          </Text>
        </Box>
      )}
      <ItemTotalBox>
        <Text size="small" color="dark-2">
          {'Item Total: '}
        </Text>
        <ItemTotalValue
          size="small"
          color="brand"
          weight="bold"
        >
          {` $${commaSeparetedValue(product.itemTotalAmount)}`}
        </ItemTotalValue>
      </ItemTotalBox>

      {product.shippingMethodCode && (
        <Box direction="row" align="center">
          <Text size="small" color="dark-2">
            {'Shipping Method: '}
          </Text>
          <ShippingMethodValue size="small">
            {orderItemShippingMethod(product.shippingMethodCode)}
          </ShippingMethodValue>
        </Box>
      )}
    </>
  )
}

export default Information
